/** @format */

import React from 'react';
import Table from 'src/ui/library/Table';
class EntityWPHorizontalTable extends React.Component {
  state = {
    showDelete: false,
    rowsSelected: [],
  };

  handleDelete = () => {};

  handleAdd = () => {};

  tableFooter = () => {
    return null;
  };

  onTableChange = (actionType, data) => {
    if (actionType === 'rowSelected') {
      const { selectedRows } = data.model;

      this.setState({
        showDelete: selectedRows.length ? true : false,
        rowsSelected: selectedRows,
      });
    }
  };

  render() {
    const {
      label,
      setUpdateModelFn,
      addNewRowFn,
      deleteRowsFn,
      elementActions,
      cancelRowsFn,
      setTableModelFn,
      setCancelSelectedRows,
      setUpdateColumnFn,
      ...otherProps
    } = this.props;
    const { pagination = false } = this.props;
    return (
      <div className={'entity-table'}>
        <span className={'table-label'}>{label}</span>
        <Table
          updateModel={setUpdateModelFn}
          setTableModel={setTableModelFn}
          updateColumn={setUpdateColumnFn}
          onTableChange={this.onTableChange}
          cancelSelectedRows={setCancelSelectedRows}
          {...otherProps}
          pagination={pagination}
          hardDisplay={false}
        />
      </div>
    );
  }
}

export default EntityWPHorizontalTable;
